import React from 'react';
import { getTestIds } from '../../utils/TestIds';
export const GetPageTID = (parentTestId)=>getTestIds(parentTestId);
export function assignForwardedRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    if (ref != null) {
        ref.current = value;
    }
}
